//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {

    //Use strict mode
    'use strict';

    /**
     * @class ColorScale
     * Class defining a color scale (or color range). This scale can be used in order to color 
     * elements according to a continuous parameter.
     *
     * @param {(String[]|Array[])} colors - Colors defining the color scale; the colors can be specifed either
     *      as strings (ex: 'red', 'blue') or as RGB triplets (ex: [255, 0, 255])
     * @param {Number[]} positions - Positions of the colors in the parameter space
     */
    module.ColorScale = function(colors, positions) {
        this._colors = [];
        if (colors != undefined) {
            this.redefine(colors, positions);
        }
    };
      
    module.ColorScale.prototype.redefine = function(colors, positions) {
        var nColors = colors.length;
        for (var iColor = 0; iColor < nColors; ++iColor) {
            var position = (positions == undefined) ? iColor * 1./(nColors - 1.) : positions[iColor];
            this.addColor(colors[iColor], position);
        }
    };
    
    module.ColorScale.prototype.addColor = function(color, position) {
        this._colors.push({value: am.utils.color2rgb(color), pos: position});
        this._colors.sort(function(a,b) {
            return a.pos - b.pos;
        });
    };
    
    module.ColorScale.prototype.getColor = function(position) {
        var outputColor = [];

        var nColors = this._colors.length;
        if (nColors < 2) {
            throw new Error("The color scale must be defined by at least 2 colors");
        }

        if (position <= this._colors[0].pos) {
            outputColor = this._colors[0].value;
        } else if (position >= this._colors[nColors - 1].pos) {
            outputColor = this._colors[nColors - 1].value;
        } else {
            for (var iColor = 1; iColor < nColors; ++iColor) {
                var currColor = this._colors[iColor - 1];
                var nextColor = this._colors[iColor];
                if (position == currColor.pos) {
                    outputColor = currColor.value;
                    break;
                } else if (position > currColor.pos && position <= nextColor.pos) {
                    var x = (position - currColor.pos)/(nextColor.pos - currColor.pos);
                    for (var iCol = 0; iCol < 3; ++iCol) {
                        outputColor[iCol] = x*(nextColor.value[iCol] - currColor.value[iCol]) + 
                            currColor.value[iCol];
                    }
                    break;
                }
            }
        }

        // Hack: Chrome and IE do not support decimal places in RGB triplets. We therefore round every color value to
        // its nearest integer!
        for (var iCol = 0; iCol < 3; ++iCol) {
            outputColor[iCol] = Math.round(outputColor[iCol]);
        }

        return outputColor;
    };

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Returns a new instance of class am.ColorScale
     *
     * @param {(String[]|Array[])} colors - Colors defining the color scale; the colors can be specifed either
     *      as strings (ex: 'red', 'blue') or as RGB triplets (ex: [255, 0, 255])
     * @param {Number[]} positions - Positions of the colors in the parameter space
     * @return {am.ColorScale} - New instance of class am.ColorScale
     */
    module.colorScale = function(colors, positions) {
        return new am.ColorScale(colors, positions);
    };

    return module;

})(am.utils || {});